import React, { Suspense } from "react"
import { Spinner, Center } from "@chakra-ui/react"

const ManageBillingTypeformModal = React.lazy(
  () =>
    import(
      "./ManageBillingTypeformModal" /* webpackChunkName: "ManageBillingTypeformModal" */
    )
)

const ManageBillingTypeformModalLazy = (props: any) => {
  return (
    <Suspense
      fallback={
        <Center>
          <Spinner />
        </Center>
      }
    >
      <ManageBillingTypeformModal {...props} />
    </Suspense>
  )
}

export default ManageBillingTypeformModalLazy
